import { jsx as _jsx } from "react/jsx-runtime";
import SharedComponents from "../SharedComponents";
const BuyButton = (props) => {
    let { renderProductBuyButton } = SharedComponents.useContext();
    if (typeof renderProductBuyButton === 'function') {
        return renderProductBuyButton(props);
    }
    return (_jsx("button", { ...props, onClick: props.onClick, children: props.children('available') }));
};
export default BuyButton;
